import { soundService } from '../../services/helperServices/SoundService';

export const handleSoundClick = ({ state }) => {
  if (state) {
    soundService.unmute();
    soundService.playSingleClick();
  } else {
    soundService.mute();
  }
}

export const handleHistoryClick = () => {
  soundService.playSingleClick();
}

export const handleInfoClick = () => {
  soundService.playSingleClick();
}